/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useEffect, useState, Suspense, lazy } from "react";
import Container from "react-bootstrap/Container";
import SpinnerLoader from "../SpinnerLoader";
import { isMobileDevice, SWMC_DOMAIN_NAME, CELLIGENCE_DOMAIN_NAME, ANGELAI_DOMAIN_NAME } from "../Utils";
import "./index.css";

const UnderMaintenance = lazy(() => import("../UnderMaintenance"));
const Header = lazy(() => import("../Header"));
const Footer = lazy(() => import("../Footer"));

export default function HomePage() {
    const [loading, setLoading] = useState(true);
    const [navBarFixed, setNavBarFixed] = useState(false);
    const [siteMapUrl, setSiteMapUrl] = useState("");
    const [eventCreatedUnderDomain, setEventCreatedUnderDomain] = useState("");
    const [isMobile, setIsMobile] = useState(isMobileDevice());

    useEffect(() => {
        function handleResize() {
            setIsMobile(isMobileDevice());
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const pageURL = new URL(window.location.href);
        const domainName = pageURL.hostname;

        // Prepare all state updates in a single object
        let updates = {
            loading: false
        };

        if (domainName.includes("swmc.com")) {
            updates = {
                ...updates,
                siteMapUrl: "https://www.swmc.com/swmc-site-map",
                eventCreatedUnderDomain: SWMC_DOMAIN_NAME,
                navBarFixed: true
            };
        } else if (domainName.includes("celligence.com")) {
            updates = {
                ...updates,
                siteMapUrl: "https://celligence.com/sitemap",
                eventCreatedUnderDomain: CELLIGENCE_DOMAIN_NAME,
                navBarFixed: true
            };
        } else {
            updates = {
                ...updates,
                siteMapUrl: "https://angelai.com/sitemap",
                eventCreatedUnderDomain: ANGELAI_DOMAIN_NAME,
                navBarFixed: false
            };
        }

        // Batch state updates
        setSiteMapUrl(updates.siteMapUrl);
        setEventCreatedUnderDomain(updates.eventCreatedUnderDomain);
        setNavBarFixed(updates.navBarFixed);
        setLoading(updates.loading);
    }, []);

    return (
        <Container fluid className="ps-0 pe-0">
            {loading ? (
                <SpinnerLoader />
            ) : (
                <Suspense fallback={<SpinnerLoader />}>
                    <div id="homePageContainer">
                        <UnderMaintenance siteMapUrl={siteMapUrl} />
                        <Header
                            eventCreatedUnderDomain={eventCreatedUnderDomain}
                            isMobile={isMobile}
                            navBarFixed={navBarFixed}
                        />
                    </div>
                    <Footer eventCreatedUnderDomain={eventCreatedUnderDomain} />
                </Suspense>
            )}
        </Container>
    );
};